var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    {
      class: { "in-main": _vm.isMain },
      staticStyle: { "touch-action": "none" },
      attrs: { id: "page-header" },
    },
    [
      _vm._t("default", function () {
        return [
          _c(
            "div",
            {
              staticClass: "omc-header web-centered",
              class: { login: _vm.isLogin },
            },
            [
              _c(
                "div",
                { staticClass: "header-shortcuts-wrapper align-items-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-itmes-center",
                      staticStyle: { gap: "10px" },
                    },
                    [
                      !_vm.isMobile && !_vm.isTablet
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.closeServiceMenu,
                                  expression: "closeServiceMenu",
                                },
                              ],
                              staticClass: "header-dropdown-wrapper",
                              on: { click: _vm.openServiceMenu },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "28",
                                  height: "25",
                                  src: `${_vm.$s3}/img/common/Header/menu.svg?${_vm.$ver}`,
                                },
                              }),
                              _vm.serviceMenu
                                ? _c(
                                    "div",
                                    { staticClass: "header-dropdown" },
                                    [
                                      _c(
                                        "Menu",
                                        _vm._b(
                                          {},
                                          "Menu",
                                          { closeMenu: _vm.closeServiceMenu },
                                          false
                                        )
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _c(
                            "base-layout-modifier",
                            {
                              staticClass:
                                "sidebar-btn btn d-inline-block d-web-none text-white-main pl-0",
                              attrs: {
                                action: "sidebarOpen",
                                variant: "alt-none",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "clamp(16px, 3vw, 26px)",
                                  height: "auto",
                                },
                                attrs: {
                                  width: "16",
                                  height: "16",
                                  src: `${_vm.$s3}/img/common/Header/menu.svg?${_vm.$ver}`,
                                },
                              }),
                            ]
                          ),
                      _c(
                        "router-link",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { to: { name: "Main" }, variant: "Main_Logo" },
                        },
                        [
                          _c("img", {
                            staticClass: "logo",
                            attrs: {
                              width: "73",
                              height: "25",
                              src: `${_vm.$s3}/img/common/Header/logo.webp?${_vm.$ver}`,
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  !_vm.isTablet
                    ? _c(
                        "div",
                        { staticClass: "shortcuts" },
                        [
                          _vm._l(
                            _vm.shortcutsWithHoliday,
                            function (shortcut, i) {
                              return [
                                !shortcut?.openDate ||
                                _vm.showMenu(shortcut?.openDate)
                                  ? _c(
                                      "button",
                                      {
                                        key: i,
                                        staticClass: "icn-route-btn",
                                        class: shortcut?.cls,
                                        on: {
                                          click: function ($event) {
                                            return _vm.routeTo(shortcut.route)
                                          },
                                          mouseover: function ($event) {
                                            return _vm.showTitle(shortcut.img)
                                          },
                                          mouseleave: function ($event) {
                                            return _vm.hideTitle()
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            width: "30",
                                            height: "30",
                                            src: `${_vm.$s3}/img/common/Header/${shortcut.img}?${_vm.$ver}`,
                                          },
                                        }),
                                        shortcut?.cls && _vm.badgeState
                                          ? _c("div", { staticClass: "dot" })
                                          : _vm._e(),
                                        _vm.shownTitle === shortcut.img &&
                                        !_vm.isMobile
                                          ? _c(
                                              "div",
                                              { staticClass: "hover-title" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.getHoverTitle(
                                                        shortcut.img
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              _c("Clover"),
              _c("OMC"),
              !_vm.isMobile
                ? [
                    !_vm.isLogin
                      ? _c(
                          "router-link",
                          {
                            staticClass: "icn-route-btn my-page",
                            attrs: {
                              to: { name: "Login" },
                              variant: "alt-none",
                            },
                            nativeOn: {
                              mouseover: function ($event) {
                                return _vm.showTitle("etc.login")
                              },
                              mouseleave: function ($event) {
                                return _vm.hideTitle()
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "icon login-icon" }),
                            _vm.shownTitle === "etc.login"
                              ? _c("div", { staticClass: "hover-title" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.getHoverTitle("login")) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : [
                          _vm._l(_vm.loginStuff, function (info, i) {
                            return _c(
                              "router-link",
                              {
                                key: i,
                                staticClass: "icn-route-btn my-page",
                                attrs: {
                                  to: { name: info.route },
                                  variant: "alt-none",
                                },
                                nativeOn: {
                                  mouseover: function ($event) {
                                    return _vm.showTitle(info.title)
                                  },
                                  mouseleave: function ($event) {
                                    return _vm.hideTitle()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    width: "30",
                                    height: "30",
                                    src: `${
                                      _vm.$s3
                                    }/img/common/Header/${info.route.toLowerCase()}.webp?${
                                      _vm.$ver
                                    }`,
                                  },
                                }),
                                _vm.shownTitle === info.title
                                  ? _c("div", { staticClass: "hover-title" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getHoverTitle(info.title)
                                          ) +
                                          "\n            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }),
                          _c(
                            "button",
                            {
                              staticClass: "icn-route-btn",
                              on: {
                                mouseover: function ($event) {
                                  return _vm.showTitle("noti")
                                },
                                mouseleave: function ($event) {
                                  return _vm.hideTitle()
                                },
                                click: function ($event) {
                                  return _vm.hideTitle()
                                },
                              },
                            },
                            [
                              _c("Alert"),
                              _vm.shownTitle === "noti"
                                ? _c("div", { staticClass: "hover-title" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.getHoverTitle("noti")) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm.isMobile
            ? _c(
                "div",
                {
                  staticClass:
                    "mobile-header d-flex align-items-center justify-content-between",
                  class: { "in-main": _vm.isMain },
                },
                [
                  _c("div"),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "mobile_shortcut d-flex align-items-center",
                        },
                        [
                          _vm._l(
                            _vm.shortcutsWithHoliday,
                            function (shortcut, i) {
                              return [
                                !shortcut?.openDate ||
                                _vm.showMenu(shortcut?.openDate)
                                  ? _c(
                                      "button",
                                      {
                                        key: i,
                                        staticClass:
                                          "shortcut text-white-main no_background pr-0",
                                        class: shortcut?.cls,
                                        on: {
                                          click: function ($event) {
                                            return _vm.routeTo(shortcut.route)
                                          },
                                        },
                                      },
                                      [
                                        shortcut.route === "Login"
                                          ? _c("div", {
                                              staticClass: "icon login-icon",
                                            })
                                          : _c("img", {
                                              attrs: {
                                                width: "26",
                                                height: "26",
                                                src: `${_vm.$s3}/img/common/Header/${shortcut.img}?${_vm.$ver}`,
                                              },
                                            }),
                                        shortcut?.cls && _vm.badgeState
                                          ? _c("div", { staticClass: "dot" })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _c(
                        "span",
                        { staticStyle: { "margin-right": "6px" } },
                        [_c("Alert")],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      }),
      _c("Modal", {
        ref: "swap-mobile-header",
        attrs: { id: "swap-mobile-header" },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }